/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
var headerWrapper = document.querySelector(".Header__Wrapper");
window.addEventListener("scroll", (e)=>{
  if(window.outerWidth < 475){
    if(window.scrollY >= 100){
      headerWrapper.style.boxShadow = "0px 0px 10px 1px #ccc";
    } else if(window.scrollY < 100){
      headerWrapper.style.boxShadow = "none";
    }
  }
})